import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08035dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "room-card" }
const _hoisted_2 = { class: "location" }
const _hoisted_3 = { class: "members" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_radio_button = _resolveComponent("radio-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_fa_icon, {
          icon: "map-marker-alt",
          size: "lg"
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.roomName), 1)
      ]),
      _createVNode(_component_fa_icon, {
        icon: "users",
        size: "lg"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, "Players logged in: " + _toDisplayString(_ctx.roomPlayersCount), 1),
      _createVNode(_component_radio_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectRoom(_ctx.roomId)))
      })
    ])
  ]))
}